import { toast } from 'react-hot-toast';

/**.
 * Hook for providing methods to create notifications.
 * https://react-hot-toast.com/docs/toast
 */ const useToast = ()=>({
        /**
     * Creates success toast.
     */ success: toast.success,
        /**
     * Dismiss all toasts or dismiss specific toast by passing a toast id.
     * Will trigger the exit animation.
     */ dismiss: (toastId)=>toast.dismiss(toastId),
        /**
     * Remove all toasts instantly or remove specific toast instantly by passing a toast id.
     * Will not trigger the exit animation.
     */ remove: (toastId)=>toast.remove(toastId)
    });

export { useToast };
//# sourceMappingURL=useToast.es.js.map
